// extracted by mini-css-extract-plugin
export default {"wrapper":"Checkbox_wrapper__VgjFS","input":"Checkbox_input__596IZ","track":"Checkbox_track__wzUtO","thumb":"Checkbox_thumb__HW2tJ","label":"Checkbox_label__JjhqG"};